import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { ManualEntryProposalColumnStatus } from '../types/maintenanceManualEntryProposal.type'

type UseMaintenanceManualEntryProposalsProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    status?: ManualEntryProposalColumnStatus;
  };
  mapper?: (data: any) => T;
  enabled?: boolean;
}

export const useMaintenanceManualEntryProposals = <T,>({
  filters: { search = '', page = 1, status } = {},
  mapper = Mapper.default<T>(),
  enabled,
}: UseMaintenanceManualEntryProposalsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceManualEntryProposals', search, page, status],
    queryFn: () => {
      return privateAxios.get(`/maintenance/establishment_choice/manual_entry_proposals`, {
        params: {
          search,
          page,
          'q[status_eq]': status,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: typeof enabled === 'boolean' ? enabled : true,
  });

  return { data, meta, ...rest }
}
